<template>
  <div>
    <TheHeader farming></TheHeader>
    <PageHeader full>
      <TextHeading variant="xl">
        Welcome to
        <br>Morrisons Farming
      </TextHeading>
    </PageHeader>
    <PageCarousel
      category="Farming Matters"
      header="Read the latest edition of our newsletter"
      info="Offering farming related articles and news which can benefit our suppliers, manufacturers and business partners."
      image01="farming-homepage.jpg"
      rounded
    ></PageCarousel>
    <PageGrid>
      <PageMain>
        <PageSection title="Latest News">
          <Cards>
            <CardsCol>
              <CardArticle
                title="We are proud of all our fresh fish and seafood sold in our stores and café."
                image="man-fish.jpg"
                date="01 Jan 2019"
                aria="Read about We are proud of all our fresh fish and seafood sold in our stores and café."
                rounded
              />
            </CardsCol>
            <CardsCol>
              <CardArticle
                title="Morrisons trials first plastic deposit return scheme in its supermarket."
                image="carrier-bags.jpg"
                date="12 Dec 2018"
                aria="Read about Morrisons trials first plastic deposit return scheme in its supermarket."
                rounded
              />
            </CardsCol>
            <CardsCol>
              <CardArticle
                title="Morrisons trials first plastic deposit return scheme in its supermarket."
                image="farmer.jpg"
                date="30 Aug 2018"
                aria="Read about Morrisons trials first plastic deposit return scheme in its supermarket."
                rounded
              />
            </CardsCol>
          </Cards>
        </PageSection>
        <PageSection title="Schemes">
          <MainBanner
            gradient
            rounded
            image="farming-cow.png"
            header="Find out more about our Dairy Beef Scheme."
          />
        </PageSection>
        <PageSection title="Latest News">
          <Cards cols="3">
            <CardsCol>
              <CardArticleFarming
                title="Cattle finance through Harrison &amp; Hetherington"
                shape="logo"
                date="01 Jan 2019"
                aria="Read about Cattle finance through Harrison and Hetherington"
                rounded
              />
            </CardsCol>
            <CardsCol>
              <CardArticleFarming
                title="Setting the standard for animal welfare"
                shape="logo"
                date="17 Dec 2018"
                aria="Read about Setting the standard for animal welfare"
                rounded
              />
            </CardsCol>
            <CardsCol>
              <CardArticleFarming
                title="Checking residency dates to avoid deductions"
                shape="logo"
                date="07 Sept 2018"
                aria="Read about Checking residency dates to avoid deductions"
                rounded
              />
            </CardsCol>
          </Cards>
        </PageSection>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>
<script>
import PageGrid from '../elements/PageGrid.vue'
import CardsCol from '../elements/CardsCol.vue'
import CardArticle from '../components/CardArticle.vue'
import CardArticleFarming from '../components/CardArticleFarming.vue'
import TheFooter from '../components/TheFooter.vue'
import Cards from '../elements/Cards.vue'
import PageCarousel from '../components/PageCarousel.vue'
import PageHeader from '../components/PageHeader.vue'
import PageSection from '../elements/PageSection.vue'
import PageMain from '../elements/PageMain.vue'
import TextHeading from '../elements/TextHeading.vue'
import TheHeader from '../components/TheHeader.vue'
import MainBanner from '../components/MainBanner.vue'
export default {
  name: 'FarmingHomepage',
  components: {
    TheHeader,
    PageCarousel,
    TextHeading,
    PageHeader,
    PageMain,
    PageSection,
    Cards,
    TheFooter,
    CardsCol,
    CardArticle,
    CardArticleFarming,
    PageGrid,
    MainBanner
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>